<script lang="ts" module>
  import type { VersionItem } from './version.types';
  import VersionButton from './VersionButton.svelte';

  export interface VersionButtonGroupProps<T extends VersionItem> {
    items: T[];
    value?: T | null | undefined;
    onselect: (item: T) => void;
    onrestore: (item: T) => void;
  }

  function getPos(index: number, items: unknown[]) {
    if (index === 0) return 'first';
    if (index === items.length - 1) return 'last';
    return 'default';
  }
</script>

<script lang="ts" generics="T extends VersionItem">
  let { items, value, onselect, onrestore }: VersionButtonGroupProps<T> = $props();
</script>

<ul class="fc">
  {#each items as item, index (index)}
    <li>
      <VersionButton
        {item}
        pos={getPos(index, items)}
        {onrestore}
        onclick={onselect}
        selected={value ? value === item : index === 0}
      />
    </li>
  {/each}
</ul>
